import type { Address } from 'app/types/address';

export type SearchAddress = Pick<
  Address,
  'id' | 'latitude' | 'longitude' | 'radiusCenterLatitude' | 'radiusCenterLongitude'
>;

export function getSearchAddressesRegion(addresses: SearchAddress[], radius: number) {
  const centers = addresses.map((address) => ({
    latitude: address.radiusCenterLatitude ?? address.latitude,
    longitude: address.radiusCenterLongitude ?? address.longitude,
  }));
  if (!centers.length) return undefined;

  const latitudePadding = radius / 111_320;
  const north = Math.max(...centers.map((center) => center.latitude + latitudePadding));
  const south = Math.min(...centers.map((center) => center.latitude - latitudePadding));
  const longitudePadding = (latitude: number) => latitudePadding / Math.max(Math.cos((latitude * Math.PI) / 180), 0.1);
  const east = Math.max(...centers.map((center) => center.longitude + longitudePadding(center.latitude)));
  const west = Math.min(...centers.map((center) => center.longitude - longitudePadding(center.latitude)));

  return {
    latitude: (north + south) / 2,
    longitude: (east + west) / 2,
    latitudeDelta: (north - south) * 1.25,
    longitudeDelta: (east - west) * 1.25,
  };
}
